// FOR UI which doesn't need to be loaded immediately but enchances UI
import tooltip from '../js/modules/tooltip';
import lightbox from '../js/modules/lightbox';

// Third-party overrides
import '../scss/third-party-overrides/override_glightbox.scss';
import '../scss/third-party-overrides/override_cookiebot.scss';

// Init modules
tooltip();
lightbox();
